import {CLOSED, MIDDLE, OPEN, KEYFRAMETARGETS } from "@km/animations/animationFactory";
import {EnumDictionary} from  "@k/js/delme_globals";
import type {useModuleColorOpenStateStore} from "@km/store/frontendstate/useModuleColorOpenState";

export enum COLORMODULE_POSSIBLE_STATES {
    closed,
    areaColorGroupSelection,
    areaOutlinePatternSelection,
    individualColorSelection,
    patterncategories,
    patterncolors,
    patterncolorIndividualColorSelection,
    patternFarbvorschlaege
}

export type ColorLayerTargetState ={
    areaColorGroupSelection: KEYFRAMETARGETS,
    areaOutlinePatternSelection: KEYFRAMETARGETS,
    areaOutlinePatternSelectListModules: KEYFRAMETARGETS,
    shadeGroupSelection: KEYFRAMETARGETS,
    shade: KEYFRAMETARGETS,
    buttons: KEYFRAMETARGETS,
    patternCategories: KEYFRAMETARGETS,
    patternSelection: KEYFRAMETARGETS,
    patternColorSelection: KEYFRAMETARGETS,
    patternColorShadeGroupSelection: KEYFRAMETARGETS,
    patternColorShadeSelection: KEYFRAMETARGETS
    patternFarbvorschlaege:KEYFRAMETARGETS
}

export const COLORLAYER_TARGET_STATES_NEW:EnumDictionary<COLORMODULE_POSSIBLE_STATES, ColorLayerTargetState> = {
    [COLORMODULE_POSSIBLE_STATES.closed]:{
    areaColorGroupSelection: CLOSED,
        areaOutlinePatternSelection: CLOSED,
        areaOutlinePatternSelectListModules: CLOSED,
        shadeGroupSelection: CLOSED,
        shade: CLOSED,
        buttons: CLOSED,
        patternCategories: CLOSED,
        patternSelection: CLOSED,
        patternColorSelection: CLOSED,
        patternColorShadeGroupSelection: CLOSED,
        patternColorShadeSelection: CLOSED,
        patternFarbvorschlaege:CLOSED
    },
    [COLORMODULE_POSSIBLE_STATES.areaColorGroupSelection]: {
    areaColorGroupSelection: OPEN,
        areaOutlinePatternSelection: CLOSED,
        areaOutlinePatternSelectListModules: CLOSED,
        shadeGroupSelection: CLOSED,
        shade: CLOSED,
        buttons: CLOSED,
        patternCategories: CLOSED,
        patternSelection: CLOSED,
        patternColorSelection: CLOSED,
        patternColorShadeGroupSelection: CLOSED,
        patternColorShadeSelection: CLOSED,
        patternFarbvorschlaege:CLOSED
    },
    [COLORMODULE_POSSIBLE_STATES.areaOutlinePatternSelection]:{
        areaColorGroupSelection: OPEN,
        areaOutlinePatternSelection: OPEN,
        areaOutlinePatternSelectListModules: OPEN,
        shadeGroupSelection: CLOSED,
        shade: CLOSED,
        buttons: MIDDLE,
        patternCategories: CLOSED,
        patternSelection: CLOSED,
        patternColorSelection: CLOSED,
        patternColorShadeGroupSelection: CLOSED,
        patternColorShadeSelection: CLOSED,
        patternFarbvorschlaege:CLOSED
    },
    [COLORMODULE_POSSIBLE_STATES.individualColorSelection]:{
        areaColorGroupSelection: CLOSED,
        areaOutlinePatternSelection: OPEN,
        areaOutlinePatternSelectListModules: MIDDLE,
        shadeGroupSelection: OPEN,
        shade: OPEN,
        buttons: OPEN,
        patternCategories: CLOSED,
        patternSelection: CLOSED,
        patternColorSelection: CLOSED,
        patternColorShadeGroupSelection: CLOSED,
        patternColorShadeSelection: CLOSED,
        patternFarbvorschlaege:CLOSED
    },
    [COLORMODULE_POSSIBLE_STATES.patterncategories]: {
        areaColorGroupSelection: CLOSED,
        areaOutlinePatternSelection: OPEN,
        areaOutlinePatternSelectListModules: MIDDLE,
        shadeGroupSelection: CLOSED,
        shade: CLOSED,
        buttons: OPEN,
        patternCategories: OPEN,
        patternSelection: OPEN,
        patternColorSelection: CLOSED,
        patternColorShadeGroupSelection: CLOSED,
        patternColorShadeSelection: CLOSED,
        patternFarbvorschlaege:CLOSED
    },
    [COLORMODULE_POSSIBLE_STATES.patterncolors]: {
        areaColorGroupSelection: CLOSED,
        areaOutlinePatternSelection: OPEN,
        areaOutlinePatternSelectListModules: CLOSED,
        shadeGroupSelection: CLOSED,
        shade: CLOSED,
        buttons: OPEN,
        patternCategories: CLOSED,
        patternSelection: CLOSED,
        patternColorSelection: OPEN,
        patternColorShadeGroupSelection: CLOSED,
        patternColorShadeSelection: CLOSED,
        patternFarbvorschlaege:CLOSED
    },
    [COLORMODULE_POSSIBLE_STATES.patterncolorIndividualColorSelection]: {
        areaColorGroupSelection: CLOSED,
        areaOutlinePatternSelection: OPEN,
        areaOutlinePatternSelectListModules: CLOSED,
        shadeGroupSelection: CLOSED,
        shade: CLOSED,
        buttons: OPEN,
        patternCategories: CLOSED,
        patternSelection: CLOSED,
        patternColorSelection: OPEN,
        patternColorShadeGroupSelection: OPEN,
        patternColorShadeSelection: OPEN,
        patternFarbvorschlaege:CLOSED
    },
    [COLORMODULE_POSSIBLE_STATES.patternFarbvorschlaege]: {
        areaColorGroupSelection: CLOSED,
        areaOutlinePatternSelection: OPEN,
        areaOutlinePatternSelectListModules: CLOSED,
        shadeGroupSelection: CLOSED,
        shade: CLOSED,
        buttons: OPEN,
        patternCategories: CLOSED,
        patternSelection: CLOSED,
        patternColorSelection: CLOSED,
        patternColorShadeGroupSelection: CLOSED,
        patternColorShadeSelection: CLOSED,
        patternFarbvorschlaege:OPEN
    }
}

export function setColorModuleState(store:ReturnType<typeof useModuleColorOpenStateStore>, state:COLORMODULE_POSSIBLE_STATES) {
    store.setCurrentState(state);
}
